import { render, staticRenderFns } from "./CreateContact.vue?vue&type=template&id=7066db0e&"
import script from "./CreateContact.vue?vue&type=script&lang=ts&"
export * from "./CreateContact.vue?vue&type=script&lang=ts&"
import style0 from "./CreateContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports